import { authenticationStore } from '@/store'
import { UntrustedLoginParams } from '@/commons/types'
import { RequestAuthenticationError, UserCredentials } from '@/store/entities'
import unAuthenticatedAxios from '@/commons/configuration/un.authenticated.axios'
import { ENVIRONMENT } from '@/commons/configuration'

export class UntrustedAuthenticationService {
    static async untrustedLogin (personCode = '', firstName = '', lastName = ''): Promise<void> {
        const requestParams: UntrustedLoginParams & Record<string, string> = {
            firstName: firstName || '',
            lastName: lastName || '',
            personCode: personCode || ''
        }

        for (const key of Object.keys(requestParams)) {
            if (!requestParams[key]) {
                delete requestParams[key]
            }
        }

        try {
            const response = await unAuthenticatedAxios.get(ENVIRONMENT.untrustedUrl, {
                params: requestParams
            })
            const userCredentials = response.data.user as UserCredentials
            userCredentials.token = response.headers['x-auth-token']
            authenticationStore.saveUserCredentials(userCredentials)
        } catch (_) {
            throw new RequestAuthenticationError([
                'errors.request.authentication.loginFailed'
            ])
        }
    }
}
